import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import BlogPostCard from "./BlogPostCard";

type Props = {
  classes: Object,
  className: string,
  pagination?: Object,
  title: string,
};

const BlogPostGrid = ({ classes, className, posts }: Props) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.grid}>
        {posts.map((post) => (
          <BlogPostCard key={post.id} post={post} className={classes.card} />
        ))}
      </div>
    </div>
  );
};

export default withStyles(() => ({
  "@global body": {
    backgroundColor: "#fff !important",
    a: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none !important",
      },
    },
  },
  root: {
    width: "100%",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gridColumnGap: "32px",
    gridRowGap: "64px",
    justifyItems: "center",
  },
  paginationWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    marginTop: "32px",
  },
}))(BlogPostGrid);
